import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Facebook from '../../legacyCore/icons/Facebook';
import Google from '../../legacyCore/icons/Google';
import LocalMed from '../../legacyCore/icons/LocalMed';
import Yelp from '../../legacyCore/icons/Yelp';
import { REVIEW_SERVICE_TYPE } from '../constants';
import style from './ReviewServiceLogo.scss';

const REVIEW_SERVICE_ICONS = {
  [REVIEW_SERVICE_TYPE.FACEBOOK]: Facebook,
  [REVIEW_SERVICE_TYPE.GOOGLE]: Google,
  [REVIEW_SERVICE_TYPE.LOCALMED]: LocalMed,
  [REVIEW_SERVICE_TYPE.YELP]: Yelp,
};

const REVIEW_SERVICE_COLORS = {
  [REVIEW_SERVICE_TYPE.FACEBOOK]: '#3b5998',
  [REVIEW_SERVICE_TYPE.GOOGLE]: '#dd4b39',
  [REVIEW_SERVICE_TYPE.LOCALMED]: '#d22a15',
  [REVIEW_SERVICE_TYPE.YELP]: '#d32323',
};

const ReviewServiceLogo = ({ className, serviceType }) => {
  const icon = REVIEW_SERVICE_ICONS[serviceType];
  const logoColor = REVIEW_SERVICE_COLORS[serviceType];
  return (
    <figure
      className={classNames(style['review-service-logo'], className)}
      style={{ backgroundColor: logoColor, borderColor: logoColor }}
    >
      {React.createElement(icon, { verticalAlign: 'center' })}
    </figure>
  );
};

ReviewServiceLogo.propTypes = {
  className: PropTypes.string,
  serviceType: PropTypes.string.isRequired,
};

export default ReviewServiceLogo;
